import { Fragment } from 'react';

/**
 * The product name in copy: "flow", set like the header wordmark (semibold, tightened, the interface font) at the
 * size of the text around it. Never for the verb ("flow the round") or the noun ("the flow").
 */
export const Brand = () => <span className="brand">flow</span>;

/** Copy that arrives as a string (an error message, a lead): the name is marked {flow} in the string. */
export const Copy = ({ children }: { children: string | null | undefined }) => {
  if (!children) return null;
  const parts = children.split('{flow}');
  return <>{parts.map((p, i) => <Fragment key={i}>{i > 0 && <Brand />}{p}</Fragment>)}</>;
};
